// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__2bviu","author":"Table_author__1CpOU","authorImage":"Table_authorImage__3n6F6","unreadRow":"Table_unreadRow__17l1g"};